<template>
  <div class="create-or-edit-mortgage-component" v-bind:class="{loaded}">
    <div class="flex-col">
      <dd-back-button></dd-back-button>
      <h1 class="pagetitle">
        Hypotheek
        <small v-if="mortgageId !== null">Bewerken</small>
        <small v-else>Aanmaken</small>
      </h1>
    </div>
    <h5>
      {{ mortgage.title }}
    </h5>
    <a-card>
      <a-tabs v-model="currentTabTitle">
        <a-tab-pane
            v-for="tab in getTabs"
            :key="tab.title"
        >
          <span slot="tab" :class="tab.class + '-header'">
            {{ tab.title }}
            <a-icon type="warning" theme="filled" v-if="tab.errorsCount > 0" style="color:red;" />
          </span>
          <component
              :is="tab.component"
              v-bind="tab.attributes"
              :active="tab.title === currentTabTitle"
              @errorsCount="(event) => $set(tab, 'errorsCount', event)"
          >
          </component>
        </a-tab-pane>
      </a-tabs>
      <span slot="actions" style="justify-content: space-between; display:flex;">
        <div style="margin: 0 10px">
        <a-button v-if="hasPrevPage" @click="prevPage">Vorige</a-button>
          </div>
        <div style="margin: 0 10px">
        <a-button type="primary" v-if="hasNextPage" @click="nextPage" class="mortgage-next">Volgende</a-button>
        <a-button :type="!hasNextPage ? 'primary' : 'default'" @click="save" :loading="saveLoading" class="mortgage-save">
          Opslaan
        </a-button>
          </div>
      </span>
    </a-card>
  </div>
</template>

<script>
import EditGeneralComponent from "./edit/EditGeneralComponent";
import EditPartsComponent from "./edit/EditPartsComponent";
import EditComponent from "~/modules/mortgage_progress/components/EditComponent";
import EditAdviseComponent from "./edit/EditAdviseComponent";
import EditDatesComponent from "./edit/EditDatesComponent";
import DocumentTypeOverviewEditComponent from "./DocumentTypeOverviewEditComponent";
import store from "~/store";
import mortgageModule from "~/modules/mortgage/store";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CreateOrEditMortgageComponent",
  props: {
    mortgageId: {
      type: Number,
      default: null
    },
    customerId: Number
  },
  data() {
    return {
      loaded: false,
      saveLoading: false,
      currentTabIndex: 0,
      tabs: [
        {
          title: 'Algemeen',
          component: EditGeneralComponent,
          attributes: {
            mortgageId: this.mortgageId,
            customerId: this.customerId,
            isEditing: this.mortgageId !== null,
          },
          onlyEdit: false,
          errorsCount: 0,
          class: 'general-tab'
        },
        {
          title: 'Leningdelen',
          component: EditPartsComponent,
          attributes: {
            mortgageId: this.mortgageId,
            isEditing: this.mortgageId !== null,
          },
          onlyEdit: false,
          errorsCount: 0,
          class: 'mortgage-parts-tab'
        },
        {
          title: 'Stukkenlijst',
          component: EditComponent,
          attributes: {
            mortgageId: this.mortgageId,
          },
          onlyEdit: true,
          errorsCount: 0,
          class: 'mortgage-progress-tab'
        },
        {
          title: 'Advies',
          component: EditAdviseComponent,
          attributes: {
            mortgageId: this.mortgageId,
            customerId: this.customerId,

          },
          onlyEdit: false,
          errorsCount: 0,
          class: 'advice-tab'
        },
        {
          title: 'Datums',
          component: EditDatesComponent,
          attributes: {
            mortgageId: this.mortgageId,
          },
          onlyEdit: false,
          errorsCount: 0,
          class: 'dates-tab'
        },
        {
          title: 'Documenten',
          component: DocumentTypeOverviewEditComponent,
          attributes: {
            mortgageId: this.mortgageId,
          },
          onlyEdit: true,
          errorsCount: 0,
          class: 'documents-tab'
        }
      ]
    }
  },
  async created() {
    if (!store.hasModule("mortgage")) {
      store.registerModule("mortgage", mortgageModule);
    }

    if (this.mortgageId !== null) {
      await this.fetchMortgage(this.mortgageId);
    } else {
      this.createEmptyMortgage(this.customerId);
    }

    this.loaded = true
  },
  methods: {
    nextPage() {
      if (this.hasNextPage) {
        this.currentTabIndex += 1;
      }
    },
    prevPage() {
      if (this.hasPrevPage) {
        this.currentTabIndex -= 1;
      }
    },
    async save() {
      try {
        this.saveLoading = true;

        await this.saveAll();

        window.location.href = route('mortgage.show', {customer: this.customerId, mortgage: this.mortgage.id});
      } catch (e) {
        if (e.response.status === 422) {
          window.scrollTo({top: 0, behavior: 'smooth'});

          this.$notification['error']({
            message: "De aangeleverde data is onjuist.",
            description: "Pas de velden aan en probeer opnieuw."
          })
        } else {
          this.$notification['error']({
            message: "Er is iets misgegaan.",
            description: "De hypotheek is niet opgeslagen, probeer het opnieuw of neem contact met ons op."
          })
        }
      } finally {
        this.saveLoading = false;
      }
    },
    ...mapActions('mortgage', [
      'fetchMortgage',
      'createEmptyMortgage',
      'saveAll',
    ])
  },
  computed: {
    getTabs() {
      return this.tabs.filter(step => {
        return this.isEditing || !step.onlyEdit
      })
    },
    hasNextPage() {
      return this.currentTabIndex < this.getTabs.length - 1;
    },
    hasPrevPage() {
      return this.currentTabIndex > 0;
    },
    currentTabTitle: {
      get() {
        return this.getTabs[this.currentTabIndex].title;
      },
      set(title) {
        return this.currentTabIndex = this.getTabs.findIndex(tab => tab.title === title);
      }
    },
    ...mapGetters({
      mortgage: 'mortgage/mortgage'
    }),
    isEditing() {
      return this.mortgageId !== null;
    }
  }
}
</script>

<style lang="scss">
.create-or-edit-mortgage-component {
  .ant-tabs-nav .ant-tabs-tab {
    height: auto;
  }
}
</style>
